<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span v-if="sign" class="row-one-title">恒宝宝定期定额充值开通</span>
      <span v-else class="row-one-title">定期定额基金买入</span>
      <Reback class="row-one-fr" @click.native="returnClick"></Reback>
    </el-row>
    <div>
      <div style="width:775px;margin:20px auto;">
        <div v-if="sign" class="d-alert">恒宝宝定额基金充值申请信息</div>
        <div v-else class="d-alert">定期定额基金买入申请信息</div>
        <el-form :model="fundFixedForm" :rules="fundFixedFormRules" ref="fundFixedFormRef" class="table-normal-form">
          <table class="table-normal-one margin-t15" cellspacing="0">
            <tbody>
              <tr>
                <td style="width:146px;">{{sign? '产品名称':'基金名称'}}</td>
                <td><span class="aColor">{{fundFixedForm.name}}</span></td>
              </tr>
              <tr>
                <td>扣款周期</td>
                <td prop="cycle">
                  <el-form-item prop="cycle">
                    <el-cascader v-model="fundFixedForm.cycle" :options="optionsZq" placeholder="**请选择**" @change="cycleChange"></el-cascader>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>充值金额</td>
                <td>
                  <el-form-item prop="price">
                    <el-input v-model="fundFixedForm.price" @input="rechargeMoney" @blur="moneyBlur"></el-input>
                    <span v-show="rangeShow" class="warnColor">{{'本基金定投金额范围（'+min+'元~'+max+'元）'}}</span>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>金额大写</td>
                <td id="capital"></td>
              </tr>
              <tr>
                <td>银行卡类型</td>
                <td>
                  <el-form-item prop="type">
                    <el-select v-model="fundFixedForm.type" @change="cardChange">
                      <el-option v-for="(item,i) in bankLists" :key="i" :label="item.bankName+'['+item.depositacctByConfusion+']'" :value="item.transactionaccountid+'-'+item.channelid+'-'+item.singledeallimit+'-'+item.singledaylimit"></el-option>
                    </el-select>
                    <span v-show="fundFixedForm.type != ''" class="warnColor" style="margin-left:68px;">{{'单笔'+SingleDealLimit+'，单日'+SingleDayLimit}}</span>
                  </el-form-item>
                </td>

              </tr>

              <tr>
                <td>交易密码</td>
                <td>
                  <el-form-item prop="passwd" :error="pwdError">
                    <el-input v-model="fundFixedForm.passwd" type="password"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>参考费率</td>
                <td><span class="warnColor">{{rate}}</span></td>
              </tr>
            </tbody>
          </table>
          <div class="btnCenter">
            <el-button type="normal" @click="Submit">确认</el-button>
            <el-button type="cancel" @click="returnClick">返回</el-button>
          </div>
        </el-form>
      </div>
      <section class="instruction">
        <div class="instruction-li">
          <p class="instruction-li-title">温馨提示</p>
          <p class="instruction-li-con">
            目前定期定额申购业务适用于农业银行卡、建设银行卡、工商银行卡、民生银行卡持有人。<br>
            定期定额申购协议开通后，请在扣款日期前存入足够金额，否则不保证此定期定额申购能够成功。 <br>
            新开户用户，如果您的基金账户开立不成功，相应的定期定额协议也失败。
          </p>
        </div>
      </section>
    </div>
    <!-- 完善信息 -->
    <Perfect></Perfect>
    <!-- 风险测评 -->
    <RiskTips @func="getFunc"></RiskTips>
    <!-- 定投成功 -->
    <el-dialog class="dialog-single-tips" title="系统提示：" :visible.sync="successDialogVisable" :show-close="false">
      <p class="dialog-single-tips-tit">定期定额申购协议开通成功</p>
      <div class="dialog-single-tips-con">
        您的交易委托已经受理，<br>
        协议号为：<strong class="rColor">{{buyplanno}}</strong> <br>
        该笔交易成功与否将以基金公司确认为准，请您及时查询<br>
        委托内容：{{sign? '恒宝宝':fundFixedForm.name}}<br>
        定投金额：<strong class="rColor">{{fundFixedForm.price + '元'}}</strong>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="openSuccess">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    const isNum = (rule, value, callback) => {
      const ret = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value < parseFloat(this.min)) {
        callback(new Error('最低买入金额是' + this.min + '元，请重新填写！'))
      } else if (value > parseFloat(this.SingleDealLimit)) {
        callback(new Error('您输入的金额超过银行卡单笔限额！'))
      } else if (!ret.test(value)) {
        callback(new Error('买入金额小数点位数不应超过2位，请重新填写！'))
      } else {
        callback()
      }
    }
    return {
      successDialogVisable: false,
      fundFixedForm: {
        name: '',
        cycle: '',
        price: '',
        type: '',
        passwd: '',
      },
      fundFixedFormRules: {
        cycle: [
          { required: true, message: '请选择扣款周期', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { validator: isNum, trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择银行卡', trigger: 'change' }
        ],
        passwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      rate: '--',
      rangeShow: true,
      optionsZq: [
        {
          label: '每日', value: '4',
        },
        {
          label: '每月', value: '0',
          children: [
            { label: '每月1日', value: '01' },
            { label: '每月2日', value: '02' },
            { label: '每月3日', value: '03' },
            { label: '每月4日', value: '04' },
            { label: '每月5日', value: '05' },
            { label: '每月6日', value: '06' },
            { label: '每月7日', value: '07' },
            { label: '每月8日', value: '08' },
            { label: '每月9日', value: '09' },
            { label: '每月10日', value: '10' },
            { label: '每月11日', value: '11' },
            { label: '每月12日', value: '12' },
            { label: '每月13日', value: '13' },
            { label: '每月14日', value: '14' },
            { label: '每月15日', value: '15' },
            { label: '每月16日', value: '16' },
            { label: '每月17日', value: '17' },
            { label: '每月18日', value: '18' },
            { label: '每月19日', value: '19' },
            { label: '每月20日', value: '20' },
            { label: '每月21日', value: '21' },
            { label: '每月22日', value: '22' },
            { label: '每月23日', value: '23' },
            { label: '每月24日', value: '24' },
            { label: '每月25日', value: '25' },
            { label: '每月26日', value: '26' },
            { label: '每月27日', value: '27' },
            { label: '每月28日', value: '28' },
          ]
        },
        {
          label: '每周', value: '1',
          children: [
            { label: '周一', value: '1' },
            { label: '周二', value: '2' },
            { label: '周三', value: '3' },
            { label: '周四', value: '4' },
            { label: '周五', value: '5' },
          ]
        },
        {
          label: '每双周', value: '2',
          children: [
            { label: '周一', value: '1' },
            { label: '周二', value: '2' },
            { label: '周三', value: '3' },
            { label: '周四', value: '4' },
            { label: '周五', value: '5' },
          ]
        }
      ],
      pwdError: '',
      // 跳转页面参数
      fundMessage: '',
      sign: false,
      // 接口参数
      fundInfo: '',
      min: '',
      max: '',
      bankLists: '',
      // 入参
      firstDateObj: '',//
      loginInfo: '',
      bankInfo: '',
      firstinvestdate: '',//第一次定投时间（天，月）
      chargecycletype: '',//投资周期类型
      investcyclevalue: '',//投资周期类型值  01
      investperiods: '',//投资周期 0,1,2
      investperiodsvalue: '',//投资周期值1,2
      investperiodsvaluedesc: '',//投资周期描述
      SingleDealLimit: '',
      SingleDayLimit: '',
      buyplanno: '',
    }
  },
  created () {
    this.fundMessage = this.$route.params.message ? this.$route.params.message : this.$route.params
    this.sign = this.$route.params.title == '恒宝宝' ? true : false
    // console.log(this.fundMessage);
    this.fundFixedForm.price = this.fundMessage.amount ? this.fundMessage.amount : ''
  },
  mounted () {
    this.getData()
    this.getDate()
    this.getFundMessage()
    this.getCardLists()
  },
  methods: {
    // 风险测试
    getFunc (val) {
      window.sessionStorage.setItem('riskFlag', val)
    },
    returnClick () {
      const path = this.$route.params.name
      if (path) {
        this.$router.push({
          name: path,
          params: {
            message: this.$route.params.message
          }
        })
      } else {
        this.$router.push({ name: 'myAssets' })
      }

    },
    // 全局数据
    getData () {
      this.$http.post(this.$apiPath.sessionId, {
        sessionId: this.$commonJs.getCookie('sessionid'),
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.loginInfo = res.data.data
      }).catch(error => { })
    },
    // 获取日期
    getDate () {
      this.$http.post(this.$apiPath.getFundDate, {
        fundcode: this.fundMessage.fundcode
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.firstDateObj = res.data.data
      }).catch(err => { })
    },
    // 单只基金详情
    getFundMessage () {
      this.$http.post(this.$apiPath.fundListone, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: this.fundMessage.fundcode
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.data.length > 0) {
          this.fundInfo = res.data.data[0]
          this.fundFixedForm.name = this.sign ? '恒宝宝' : '（' + this.fundMessage.fundcode + '）' + this.fundInfo.fundname
          this.min = this.fundInfo.per_min_39
          this.max = this.fundInfo.per_max_39
          // console.log(this.fundInfo);
        } else {
          this.fundFixedForm.name = this.fundMessage.fundcode
        }
      }).catch(err => { })
    },
    // 银行卡列表
    getCardLists () {
      this.$http.post(this.$apiPath.myBankList, {
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(res => {
        // console.log(res);
        if(res.data.code == 200) {
          const bankLists = res.data.data
          if (bankLists.length > 0) {
            var newBankList = new Array();
            for (var i = 0; i < bankLists.length; i++) {
              bankLists[i].bankName = this.$commonJs.getBankName(bankLists[i].channelid).split("-")[1]// 建设银行
              if (bankLists[i].flag == "1") {
                newBankList.unshift(bankLists[i])
              } else {
                newBankList.push(bankLists[i])
              }
            }
            this.bankLists = newBankList
            this.fundFixedForm.type = this.bankLists[0].transactionaccountid + '-' + this.bankLists[0].channelid + '-' + this.bankLists[0].singledeallimit + '-' + this.bankLists[0].singledaylimit
            this.SingleDealLimit = this.bankLists[0].singledeallimit
            this.SingleDayLimit = this.bankLists[0].singledaylimit
            this.bankLists.forEach(item => {
              if (this.fundFixedForm.type.split('-')[0] == item.transactionaccountid) {
                this.bankInfo = item
                // console.log(this.bankInfo);
              }
            });
          }
        }
      }).catch(err => { })
    },
    //金额大写
    rechargeMoney () {
      this.$commonJs.amountWords(this.fundFixedForm.price, 'capital')
    },
    async Submit () {
      var tradeStateCode = await this.tradeState(this.fundMessage.fundcode)
      if (tradeStateCode != "1") {
        this.$confirm('当前基金处于不可申购状态，是否继续开通定投计划', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.open()
        }).catch(() => {
          return
        });
      } else {
        this.open()
      }
    },
    // 判断银行卡签约
    // bankcardSigning () {
    //   this.pwdError = ''
    //   this.moneyBlur()
    //   this.$refs.fundFixedFormRef.validate(valid => {
    //     if (!valid) return
    //     this.$http.post(this.$apiPath.checkBankInfoDES, {
    //       type: '1',
    //       depositacct: this.$des.enString(this.bankInfo.depositacct, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
    //       idcode: this.$des.enString(Base64.decode(this.$commonJs.getCookie('u_id')), this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
    //     }).then(res => {
    //       // console.log(res);
    //       if (res.data.code == "200" && res.data.success) {
    //         this.open()
    //       } else {
    //         this.notHfSigned()
    //       }
    //     })
    //   })
    // },
    // 未签约跳转
    notHfSigned () {
      this.$router.push({
        name: 'bankCardVerificationHf',
        params: {
          name: 'fixedBuyOpen',
          fundMessage: this.fundMessage,//基金信息
          cardMessage: {//银行卡信息
            depositacct: this.bankInfo.depositacct,
            moneyaccount:  this.bankInfo.moneyaccount,
            paycenterid: this.bankInfo.paycenterid,
            channelid: this.bankInfo.channelid,
          }
        }
      })
    },
    open () {
      // 开通定投
      this.$http.post(this.$apiPath.checkBeforeAutoSavePlan, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        tano: this.fundInfo.tano,//
        passwd: this.$des.enString(this.fundFixedForm.passwd, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),//密码
        firstinvestamount: this.fundFixedForm.price,//金额
        fundcode: this.fundMessage.fundcode,
        channelid: this.bankInfo.channelid,
        paycenterid: this.bankInfo.paycenterid,
        moneyaccount: this.bankInfo.moneyaccount,
        depositacct: this.bankInfo.depositacct,
        firstinvestdate: this.firstinvestdate,//-首次执行日期  %
        investmode: '2',//-后续投资方式(0：按余额比例扣款；1：按递增金额扣款；2：按后续投资金额不变)
        continueinvestamount: this.fundFixedForm.price,//金额
        investperiods: this.investperiods,//投资周期( 0：每隔1月
        investperiodsvalue: this.investperiodsvalue,//投资周期值1,2
        buyflag: '1',//强制购买标志
        riskmatching: '1',
        saveplanflag: '1', //1普通定投  2智能定投(变动定投规则A) 3智能定投(目标锁定规则B) 4智能定投(区间定投规则C) a组合定投
        certificatetype: this.loginInfo.custInfo.certificatetype,
        certificateno: this.loginInfo.custInfo.certificateno,
        investcycle: this.chargecycletype,//投资周期类型　每月　每周　每双周　每十天
        investcyclevalue: this.investcyclevalue,//投资周期类型值　每月:每月X号　每周:周X　每双周:第n个周X　每十天:第X天
        investtime: '', //终止条件(0：终止日期；1：扣款期数；2：累计扣款金额)
        investtimevalue: '',//终止条件值
        referral: '',//推荐人姓名
        refermobile: '',
        baseindex: '',//-基准指数
        indextype: '', //-指数类型(属性值) 恒指，上证指数..
        transactorname: '',//未成年人监护人信息
        transactorcerttype: '',
        transactorcertno: '',
        referralprov: '',//推荐人省份
        referralcity: '',//推荐人城市
        buyplanname: '',
        custmanagerid: '',//客户经理代码
        sharetype: 'A'
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code == '200') {
          this.buyplanno = res.data.data.buyplanno
          this.openFixed(res.data.data)
        } else {
          this.pwdError = res.data.data.msg
        }
      }).catch(error => { })
    },
    // 定投
    openFixed (success) {
      this.$http.post(this.$apiPath.signSend, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        saveplanno: success.buyplanno,
        moneyaccount: this.bankInfo.moneyaccount,
        applicationamount: this.fundFixedForm.price,
        fundname: this.fundInfo.fundname,
        certIdLength: 18,//
        fundcode: this.fundInfo.fundcode,
        appsheetserialno: success.appsheetserialno,
        firstinvestdate: success.firstinvestdate,
        channelid: this.bankInfo.channelid
      }).then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.code !== '200') return
        this.successDialogVisable = true
        // 推送消息
        this.$store.dispatch({
          type: "pushNews",
          index: 9,
          fundname: this.fundInfo.fundname,
          money: this.fundFixedForm.price,
          dtDate: this.investperiodsvaluedesc,
          fundname2: ''
        })
      }).catch(err => { })
    },
    // 定投成功
    openSuccess () {
      this.successDialogVisable = false
      if (this.sign) {
        this.$router.push({ name: 'fixedInvestment' })
      } else {
        this.$router.push({
          name: 'fixedManagement',
          params: {
            active: '2'
          }
        })
      }
    },
    moneyBlur () {
      this.getRate()
      this.$refs.fundFixedFormRef.validateField('price', (err) => {
        this.rangeShow = err != '' ? false : true
      })
    },
    cycleChange (val) {
      this.chargecycletype = val[0]
      this.investcyclevalue = val[1]
      if (val[0] == "0") {//月
        this.firstinvestdate = val[1]
        this.investperiods = "0"
        this.investperiodsvalue = "1"
        this.investperiodsvaluedesc = '每月' + val[1] + '日';
      } else if (val[0] == "1") {//周
        this.investperiods = "1"
        this.investperiodsvalue = "1"
        this.investperiodsvaluedesc = '每周' + this.$parameterConfig.p_perweek[val[1]]
      } else if (val[0] == "2") {//双周
        this.investperiods = "1"
        this.investperiodsvalue = "2"
        this.investperiodsvaluedesc = '每双周' + this.$parameterConfig.p_perweek[val[1]]
      } else if (val[0] == "4") {//每天
        this.investperiods = "2"
        this.investperiodsvalue = "1"
        this.investperiodsvaluedesc = '每1天';
        this.investcyclevalue = '1'
        // 获取每日首次定投时间
        var day = new Date();
        var s3 = '' + day.getFullYear();
        if (this.firstDateObj.expectcfmdate) {
          if (parseInt(day.getMonth() + 1) > parseInt(this.firstDateObj.expectcfmdate.split("-")[0])) {
            s3 = (parseInt(s3) + 1) + '';
          }
        }
        s3 += this.firstDateObj.expectcfmdate.split("-")[0];
        s3 += this.firstDateObj.expectcfmdate.split("-")[1];
        this.firstinvestdate = s3//首次扣款日期
      }
    },
    cardChange (val) {
      this.SingleDealLimit = val.split('-')[2]
      this.SingleDayLimit = val.split('-')[3]
      this.bankLists.forEach(item => {
        if (this.fundFixedForm.type.split('-')[0] == item.transactionaccountid) {
          this.bankInfo = item
        }
      });
    },
    // 银行卡购买状态
    async tradeState (fundCode) {
      const res = await this.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=getFundStatus&fundCode=' + fundCode)
      if (res.status !== 200) return
      return res.data.Code
    },
    // 费率
    getRate () {
      this.$http.post(this.$apiPath.getRateFee, {
        businesscode: '39',
        sharetype: this.fundInfo.shareclasses,
        tano: this.fundInfo.tano,
        applicationamount: this.fundFixedForm.price,
        applicationvol: 0,
        fundcode: this.fundMessage.fundcode,
        channelid: this.bankInfo.channelid
      }).then(res => {
        if (res.status !== 200) return
        const result = res.data.data
        if (res.data.code == '200') {
          if (result.length > 0) {
            if (result[0].benchmarkrates == 0) {
              this.rate = '基准费率'
            } else {
              if (this.$commonJs.ForDight(result[0].chargerate * 100, 4) <= 100) {
                this.rate = this.$commonJs.ForDight(result[0].chargerate * 100, 4) + '%'
              } else if (this.$commonJs.ForDight(result[0].chargerate * 100, 4) == 0) {
                this.rate = '基准费率'
              } else {
                this.rate = '固定金额：' + this.$commonJs.ForDight(result[0].chargerate, 4) + '元'
              }
            }
          }
        } else {
          this.rate = result[0].msg
        }
      }).catch(err => { })
    }
  }
}
</script>

<style lang="less" scoped>
.table-normal-one tbody td {
  padding: 10px 9px;
}
</style>